"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  grid-area: content;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  grid-area: sidebar;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  grid-area: header;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    grid-template-areas: \"sidebar header\" \"sidebar content\";\n    grid-template-columns: 256px 1fr;\n    grid-template-rows: 56px calc(100vh - 56px);\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    grid-template-areas: \"sidebar header\" \"sidebar content\";\n    grid-template-columns: 56px 1fr;\n    grid-template-rows: 56px calc(100vh - 56px);\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  margin: 0;\n  padding: 0;\n\n  display: grid;\n  grid-template-areas: \"sidebar header\" \"content content\";\n  grid-template-columns: 1fr 56px;\n  grid-template-rows: 56px calc(100vh - 56px);\n\n  ", "\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable import/prefer-default-export */

var styled_components_1 = __importDefault(require("styled-components"));

var bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");

exports.Wrapper = styled_components_1["default"].div(_templateObject(), bitcoincom_pkg_theme_1.media.sm(_templateObject2()), bitcoincom_pkg_theme_1.media.md(_templateObject3()));
exports.Header = styled_components_1["default"].div(_templateObject4());
exports.Sidebar = styled_components_1["default"].div(_templateObject5());
exports.Content = styled_components_1["default"].div(_templateObject6());